module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-gtag@4.25.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@1_syqeeohjag3aylobdkynhu4eni/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":[null]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-transition-link@1.20.5_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[],"layout":"/workspace/src/components/Layout.tsx"},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-styled-components@6.16.0_babel-plugin-styled-components@2.1.4_@babel+core@7.29._3f4ohtykqro2ggnb7iywne7s7q/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@18.3.1__nquu4idgp7pmcikypsfniydgou/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
